const findEntity = () => {
  const arr = window.dataLayer || [];
  const { content } = arr.find((o) => o && o.content && o.content.id) || {};
  return content ? {
    id: content.id,
    ns: `base.allured-all.content-${content.type}`,
    name: content.name,
    props: { type: content.type, published: content.published },
  } : null;
};

// NOTE: on focus on email input is not currently handeld & sumit is hooked on login link sent.
export default (EventBus) => {
  const emitContentGateEvent = ({ action, data }) => {
    const entity = findEntity();
    EventBus.$emit('identity-x-newsletter-form-action', {
      ...data,
      category: 'Content Gate',
      action,
      ...(entity && { entity }),
    });
  };

  // in content login form VIEW
  EventBus.$on('identity-x-login-mounted', (data) => {
    const { actionSource } = data;
    if (actionSource === 'contentGate') emitContentGateEvent({ action: 'View', data });
  });

  // in content login form SUBMIT
  EventBus.$on('identity-x-login-link-sent', (data) => {
    const { actionSource } = data;
    if (actionSource === 'contentGate') emitContentGateEvent({ action: 'Submit', data });
  });

  // in content login form ERROR
  EventBus.$on('identity-x-login-errored', (data) => {
    const { actionSource } = data;
    if (actionSource === 'contentGate') emitContentGateEvent({ action: 'Error', data });
  });
};
